/**
 * Simple matching function for the default case where our entity and hierarch both have an id
 */
export function simpleIdMatcher(
  entity1: { id: string },
  entity2: { id: string }
) {
  return entity1.id === entity2.id;
}
